import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import AdminLayout from './AdminLayout';
import DefaultLayout from './DefaultLayout';
import { RootState } from '../redux/reducers';
import UnitAdminLayout from './UnitAdminLayout';
import { CONFIG } from '../utils/config';
import { authService } from '../utils/authServices';

interface LayoutWrapperProps {
  children: ReactNode;
  activeSection?: string;
}


const LayoutWrapper: React.FC<LayoutWrapperProps> = ({ children}) => {
  const primaryRole = authService.getPrimaryRole();
  

  // Example: Get `isAuthenticated` from Redux state
  const isAuthenticated = useSelector((state: RootState) => state.auth.isAuthenticated);

  // Redirect or render unauthenticated layout
  if (!isAuthenticated) {
    return <DefaultLayout>{children}</DefaultLayout>;
  }

  // Role-based layout rendering
  if (primaryRole === 'admin') {
    return <AdminLayout>{children}</AdminLayout>;
  }

  if (primaryRole === 'unitadmin') {
    return <UnitAdminLayout >{children}</UnitAdminLayout>;
  }

  // Default layout for missing or unknown roles
  return <DefaultLayout >{children}</DefaultLayout>;
};




export default LayoutWrapper;
